import { useEffect, useState } from "react";
import "./style.css"
import { useDispatch, useSelector } from "react-redux";
import { setMessage, setProfil } from "../../redux";

function Access() {
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);
    const [requestUsers, setRequestUsers] = useState([]);
    const [accessUsers, setAccessUsers] = useState([]);
    const [updt, setUpdt] = useState(false);
    const profil = useSelector(state => state.profil);

    useEffect(() => {
        const fetchUsers = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/users/get`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
            });
            const res = await req.json();
            dispatch(setMessage());

            if (req.status !== 200) {
                localStorage.removeItem('email');
                localStorage.removeItem('password');
                sessionStorage.removeItem('email');
                sessionStorage.removeItem('password');
                window.location.reload();
                return;
            }
            setUsers(res);
        }
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        fetchUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const requests = users.filter(user => profil?.accessRequest?.includes(user._id));
        setRequestUsers(requests);

        const access = users.filter(user => profil?.accessList?.includes(user._id));
        setAccessUsers(access);
    }, [users, profil]);

    const switchStatus = (bool) => {
        dispatch(setProfil({ ...profil, access: bool }));
        setUpdt(!updt);
    }

    const toggleStatus = async () => {
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/toggle-access/${profil._id}`, {
            method: 'PATCH',
            headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
        });
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) alert(res.message);

        if (req.status === 404 || req.status === 401) {
            localStorage.removeItem('email');
            localStorage.removeItem('password');
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('password');
            window.location.reload();
        }
        if (req.status !== 200) return;

        setTimeout(() => {
            dispatch(setMessage(`Mise à jour du effectuée`));

            dispatch(setProfil({
                ...profil,
                access: res.access
            }));

            setUpdt(false);

            setTimeout(() => dispatch(setMessage()), 2000);
        }, 500);
    }

    const acceptRequest = async (requesterId) => {
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/accept-request/${profil._id}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ requesterId })
        });
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) alert(res.message);

        if (req.status === 404 || req.status === 401) {
            localStorage.removeItem('email');
            localStorage.removeItem('password');
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('password');
            window.location.reload();
        }
        if (req.status !== 200) return;

        setTimeout(() => {
            dispatch(setMessage(`Demande accepté`));

            dispatch(setProfil({
                ...profil,
                accessRequest: profil.accessRequest.filter(p => p !== requesterId),
                accessList: [...profil.accessList, requesterId]
            }));

            setTimeout(() => dispatch(setMessage()), 2000);
        }, 500);
    }

    const deniedRequest = async (requesterId) => {
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/reject-request/${profil._id}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ requesterId })
        });
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) alert(res.message);

        if (req.status === 404 || req.status === 401) {
            localStorage.removeItem('email');
            localStorage.removeItem('password');
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('password');
            window.location.reload();
        }
        if (req.status !== 200) return;

        setTimeout(() => {
            dispatch(setMessage(`Demande refusé`));

            dispatch(setProfil({
                ...profil,
                accessRequest: profil.accessRequest.filter(p => p !== requesterId)
            }));

            setTimeout(() => dispatch(setMessage()), 2000);
        }, 500);
    }

    const removeAccess = async (targetId) => {
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/remove-access/${profil._id}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ targetId })
        });
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) alert(res.message);

        if (req.status === 404 || req.status === 401) {
            localStorage.removeItem('email');
            localStorage.removeItem('password');
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('password');
            window.location.reload();
        }
        if (req.status !== 200) return;

        setTimeout(() => {
            dispatch(setMessage(`L'utilisateur a bien été retiré`));

            dispatch(setProfil({
                ...profil,
                accessList: profil.accessList.filter(p => p !== targetId)
            }));

            setTimeout(() => dispatch(setMessage()), 2000);
        }, 500);
    }

    return profil && (
        <div className="page_access">
            <section className="manager">
                <h1>Paramétres & Demandes d'accès</h1>

                <p className="text">Vous pouvez choisir ici si votre profil est public ou privé. Un profil public permet à tous les utilisateurs d’accéder à vos informations, tandis qu’un profil privé limite l’accès uniquement aux personnes que vous avez autorisées.</p>

                <div className="head">
                    <h2>- Modifiez la visibilité de votre profil</h2>
                    <p className="text">Si vous n'êtes pas sûr, il vous est conseillé de laisser votre profil en privé.</p>
                </div>

                <ul className="access_status_selector">
                    <li>
                        <button onClick={() => switchStatus(false)}>
                            <i className={`checkBox ${!profil.access ? 'checkBoxActif' : ''}`}></i>
                            <p>
                                Profil privé
                                <span>Les informations privées telles que "Coordonnées du professionnel", "Outils de communication", "Modalités de contact", "Informations attendues" ainsi que "Informations importantes" resteront privées. Seuls les comptes autorisés pourront voir ces informations.</span>
                            </p>
                        </button>
                    </li>
                    <li>
                        <button onClick={() => switchStatus(true)}>
                            <i className={`checkBox ${profil.access ? 'checkBoxActif' : ''}`}></i>
                            <p>
                                Profil publique
                                <span>Vos informations seront visible pour tous les utilisateurs inscript à l'annuaire PSOA</span>
                            </p>
                        </button>
                    </li>
                </ul>

                {updt && <button className="btn_update" onClick={toggleStatus}>Mettre à jour</button>}
            </section>

            <section className="sect_request_access">
                <div className="head">
                    <h2>- Demandes d'accès reçues</h2>
                    <p className="text">Choisissez d’accepter ou de refuser les demandes reçues. Vous gardez ainsi le contrôle sur les personnes autorisées à voir votre profil.</p>
                </div>

                {requestUsers.length !== 0 &&
                    <ul className="request_list">
                        {requestUsers.map((user, idx) => (
                            <li>
                                <button className="onglet">
                                    <p><span>Profession :</span> {user.profession}</p>
                                    <p><span>Nom et Prénom :</span> {user.lastName} {user.firstName}</p>
                                    <p><span>Lieu d'exercice :</span> {user.mainLocation}</p>
                                    <p><span>Note :</span> {user.importantInfo || 'Aucune note'}</p>
                                </button>

                                <div className="panel">
                                    <button className="btn_denied" onClick={() => deniedRequest(user._id)}>Refuser</button>
                                    <button className="btn_accept" onClick={() => acceptRequest(user._id)}>Accepter</button>
                                </div>
                            </li>
                        ))}
                    </ul>
                }

                {requestUsers.length === 0 &&
                    <ul className="request_list_empty">
                        <li>Aucune demande reçue</li>
                    </ul>
                }
            </section>

            <section className="sect_access_list">
                <div className="head">
                    <h2>- Liste utilisateurs autorisés</h2>
                    <p className="text">Les utilisateurs affichés ci-dessous peuvent consulter l’intégralité de votre profil qu'il soit "public" ou "privé".</p>
                </div>

                {accessUsers.length !== 0 &&
                    <ul className="request_list">
                        {accessUsers.map((user, idx) => (
                            <li>
                                <button className="onglet">
                                    <p><span>Profession :</span> {user.profession}</p>
                                    <p><span>Nom et Prénom :</span> {user.lastName} {user.firstName}</p>
                                    <p><span>Lieu d'exercice :</span> {user.mainLocation}</p>
                                    <p><span>Note :</span> {user.importantInfo || 'Aucune note'}</p>
                                </button>

                                <div className="panel">
                                    <button className="btn_denied" onClick={() => removeAccess(user._id)}>Retirer l'accès</button>
                                </div>
                            </li>
                        ))}
                    </ul>
                }

                {accessUsers.length === 0 &&
                    <ul className="request_list_empty">
                        <li>Aucun utilisateur autorisé</li>
                    </ul>
                }
            </section>
        </div>
    )
}

export default Access;